'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var User = function User(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 18 20' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'g',
        { fill: 'currentColor', fillRule: 'evenodd' },
        _react2.default.createElement('path', { d: 'M8.904.008c-3.21 0-5.898 2.532-5.898 5.667 0 .1-.004.184-.018.42l-.01.188c-.017.347-.011.584.036.797l.324-.072-.315-.106a.713.713 0 0 0-.024.356c.018.1.032.14.104.321a.69.69 0 0 1 .069.262c0 1.081.458 2 1.163 2 .15 0 .285-.048.42-.132l-.174-.284-.323.08c.657 2.657 2.502 4.503 4.646 4.503 2.202 0 4.421-2.008 5.058-4.586l-.322-.08-.175.283c.136.084.27.132.42.132.704 0 1.084-.879 1.084-1.999 0-.368-.055-.722-.156-1.03l-.316.106.325.071c.097-.445.147-.838.147-1.23 0-3.11-2.825-5.667-6.065-5.667zm5.269 6.755a.334.334 0 0 0 .009.176c.079.238.122.521.122.819 0 .79-.234 1.333-.418 1.333-.009 0-.031-.008-.071-.033a.332.332 0 0 0-.498.203c-.567 2.298-2.538 4.08-4.413 4.08-1.8 0-3.411-1.611-4-3.996a.332.332 0 0 0-.498-.203c-.04.025-.062.033-.07.033-.214 0-.5-.574-.5-1.334 0-.176-.036-.31-.116-.51a.99.99 0 0 1-.066-.189.467.467 0 0 0 .009-.206c-.03-.138-.036-.33-.021-.62l.01-.182c.014-.25.018-.34.018-.46 0-2.756 2.383-5 5.234-5 2.887 0 5.4 2.275 5.4 5 0 .34-.044.687-.131 1.089z',
          fillRule: 'nonzero' }),
        _react2.default.createElement('path', { d: 'M16.681 19.353v-.558c0-1.709-1.221-3.606-2.683-4.134l-1.885-.68.703-.181c-1.11 1.256-2.548 1.965-4.075 1.965-1.527 0-2.965-.71-4.075-1.965l.704.182-1.886.68C2.077 15.168.99 17.013.99 18.794v.558H.335v-.558c0-.036 0-.072.002-.108h16.997l.001.108v.558h-.654zm-2.465-5.32c1.767.638 3.12 2.821 3.12 4.762v.558h-17v-.558c0-1.94 1.163-4.124 2.93-4.762l1.886-.68c.97 1.099 2.23 1.745 3.589 1.745 1.36 0 2.619-.646 3.59-1.745l1.885.68z',
          fillRule: 'nonzero' }),
        _react2.default.createElement('ellipse', { cx: '7.012', cy: '8.012', rx: '.668', ry: '.668' }),
        _react2.default.createElement('ellipse', { cx: '11.018', cy: '8.012', rx: '.668', ry: '.668' }),
        _react2.default.createElement('path', { d: 'M4.675 7.352c.181 0 .33-.144.334-.325a12.301 12.301 0 0 1 .106-1.298c.085-.62.24-1.047.228-1.047.064 0 .036-.002.364.02.378.025.638.03.919.007 1.054-.088 1.721-.606 1.721-1.696H7.68c0 1.217 2.647 3.004 5.007 3.004l-.334-.334c0 .397.15.777.393 1.131.142.206.284.36.385.452a.334.334 0 0 0 .224.086h1.001a.334.334 0 0 0 0-.667h-1.001l.224.086a2.041 2.041 0 0 1-.283-.336c-.174-.252-.275-.51-.275-.752a.334.334 0 0 0-.334-.334c-2.034 0-4.34-1.556-4.34-2.336 0-.446-.667-.446-.667 0 0 .686-.365.969-1.11 1.031-.239.02-.471.015-.818-.008-.363-.025-.321-.022-.41-.022-.536 0-.744.574-.889 1.624a12.949 12.949 0 0 0-.112 1.372l.334-.325H3.674a.334.334 0 1 0 0 .667h1.001z',
          fillRule: 'nonzero' })
      )
    )
  );
};
/*eslint-enable */

exports.default = User;
//# sourceMappingURL=User.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/User.js